import { useEffect, useState } from "react";
import axios from "axios";

export default function ResumenMensual({ mes, setMes }) {

  const [resumen, setResumen] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchResumen = async (mesSeleccionado) => {
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/resumen?mes=${mesSeleccionado}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
      }
      });

      if (res.data.success) {
        setResumen(res.data.data);
      } else {
        alert("No se pudo cargar el resumen");
      }
    } catch (err) {
      console.error(err);
      alert("Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResumen(mes);
  }, [mes]);

  return (
    <div>
      <h2>Resumen mensual</h2>

      <label>Selecciona mes: </label>
      <input
        type="month"
        value={mes}
        onChange={(e) => setMes(e.target.value)}
      />

      {loading ? (
        <p>Cargando...</p>
      ) : resumen ? (
        <div style={{ marginTop: "1rem", border: "1px solid #ccc", padding: "1rem", borderRadius: "8px" }}>
          <p><strong>Salarios:</strong> ${resumen.salarios.toLocaleString()}</p>
          <p><strong>Ingresos extra:</strong> ${resumen.extras.toLocaleString()}</p>
          <p><strong>Total ingresos:</strong> ${resumen.ingresos.toLocaleString()}</p>
          <p><strong>Gastos:</strong> ${resumen.gastos.toLocaleString()}</p>
          <p><strong>Balance:</strong> <span style={{ color: resumen.balance >= 0 ? "green" : "red" }}>
            ${resumen.balance.toLocaleString()}
          </span></p>
        </div>
      ) : (
        <p>No hay datos para este mes.</p>
      )}
    </div>
  );
}
